<div class="cp-drawer-body">
  <form #changeOrderNotificationForm="ngForm" name="changeOrderNotificationForm">
    <div>
      <div class="pb-3 pt-3">
        <label class="pr-2 label-alignment"><strong>Communities</strong></label>
        <p-toggleswitch name="switch" [(ngModel)]="isSwitchOn" [disabled]="((notificationViewModel.selectedCommunities | hasValue) || allCommChbx) || (notificationViewModel.selectedSubGroup)" />
        <label class="pl-2 pr-3 label-alignment"><strong>Subgroups</strong></label>
      </div>
      <div class="pb-2">
        <b>{{errorMessage}}</b>
      </div>
      @if (isSwitchOn) {
        <div class="pb-3">
          <div class="row col-12">
            <label><strong>Subgroups </strong></label>
          </div>
          <div class="row col-12">
            <p-select [options]="subGroupOptions" optionLabel="subGroupName" name="subGroup"
              [(ngModel)]="notificationViewModel.selectedSubGroup"
              placeholder="Select a Subgroup"
              [showClear]="true"
              (onChange)="onHandleSubGroupChange()" />
          </div>
          @if (notificationViewModel.selectedSubGroup) {
            <div class="row col-12">
              <p-listbox fluid [options]="subGroupCommunityOptions" name="commMultiSelect"
                multiple="multiple" checkbox="checkbox" filter="true" placeholder="Select Community(s)"
                [listStyle]="{'max-height':'250px', 'width':'350px'}" class="pt-3" [showToggleAll]="true"
                [disabled]="(notificationViewModel.selectedSubGroup && notificationViewModel.selectedSubGroup.subGroupID > 0)">
                <ng-template let-comm #comm>
                  {{comm.orgName}} - ({{comm.sourceKey}})
                </ng-template>
              </p-listbox>
            </div>
          }
        </div>
      }
      @if (!isSwitchOn) {
        <div class="pb-3">
          <label><strong>Communities</strong></label>
          <div class="row col-12">
            <p-checkbox class="ml-4 pb-2" name="allComm" label="Notifications for ALL Communities"
              [(ngModel)]="allCommChbx" binary="true"
            [disabled]="(notificationViewModel.selectedSubGroup && notificationViewModel.selectedSubGroup.subGroupID > 0)" (onChange)="onHandleCommChbxChange($event)" />
          </div>
          <p-listbox fluid [options]="communityOptions" name="commMultiSelect" [(ngModel)]="notificationViewModel.selectedCommunities"
            multiple="multiple" checkbox="checkbox" filter="true" placeholder="Select Community(s)"
            [listStyle]="{'max-height':'250px'}" class="pt-1" [showToggleAll]="true"
            (onChange)="onHandleCommChange($event)"
            [disabled]="(notificationViewModel.selectedSubGroup && notificationViewModel.selectedSubGroup.subGroupID > 0) || (allCommChbx && !(notificationViewModel.selectedCommunities| hasValue))">
            <ng-template let-comm #comm>
              {{comm.orgName}} - ({{comm.sourceKey}})
            </ng-template>
            <p-footer>
              @if (notificationViewModel.selectedCommunities?.length <= 5) {
                <div>
                  @for (comm of notificationViewModel.selectedCommunities; track comm; let i = $index) {
                    <span>
                      {{comm.orgName}}({{comm.sourceKey}}){{i + 1 !== notificationViewModel.selectedCommunities.length ? ', '
                      :''}}
                    </span>
                  }
                </div>
              }
              @if (notificationViewModel.selectedCommunities?.length > 5) {
                <div>
                  <span>{{notificationViewModel.selectedCommunities.length}} Communities selected.</span>
                </div>
              }
            </p-footer>
          </p-listbox>
        </div>
      }
    </div>
  </form>
</div>

<div class="cp-drawer-footer">
  <!--#region SideBar Buttons  -->
  <pcp-commandbar *checkAccess="Claims.manage_co_notifications">
    <command-button button-left [text]="ButtonText.Close" [iconClasses]="['fas fa-window-close']"
      (commandClick)="onClose()" [enabled]="!changeOrderNotificationForm.form.dirty" />
    <command-button button-right [text]="ButtonText.Save" [iconClasses]="['fas fa-check']"
      [enabled]="changeOrderNotificationForm.form.dirty" (commandClick)="onSave()" />
    <command-button button-right [text]="ButtonText.Cancel" [iconClasses]="['fas fa-undo']"
      [enabled]="changeOrderNotificationForm.form.dirty" (commandClick)="onCancel()" />
  </pcp-commandbar>
  <!--#endregion -->
</div>